import { getMarkRange } from "@tiptap/core";
import type { Editor } from "@tiptap/vue-3";

export const stripProtocol = (u: string) => u.replace(/^https?:\/\//i, "");

export const normalizeUrl = (url: string) => {
	const trimmed = url.trim();
	if (!trimmed) return "";
	if (!/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(trimmed)) return "https://" + trimmed;
	return trimmed;
};

export const moveCaretOutOfLink = (editor: Editor) => {
	const { to } = editor.state.selection;
	const markType = editor.state.schema.marks.link;
	const targetPos = Math.max(1, to - 1);
	let range = getMarkRange(editor.state.doc.resolve(targetPos), markType);
	if (!range) range = getMarkRange(editor.state.doc.resolve(to), markType);
	if (range) {
		editor.chain().focus().setTextSelection(range.to).unsetAllMarks().run();
	} else {
		editor.chain().focus().unsetAllMarks().run();
	}
};
